import MainMenu from '@/lib/components/Navigation/MainMenu.vue';
import store from '@/lib/store';
import Vue from 'vue';

const initMainMenu = () => {
	const mainMenuEl = document.getElementById('main-menu');

	if (mainMenuEl) {
		new Vue({
			el: mainMenuEl,
			name: 'MainMenuApp',
			components: {
				MainMenu,
			},
			store,
		});
	}
};

export default initMainMenu;
